import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        cameras: [
            { id: 0, alias: 'front' },
            { id: 1, alias: 'inward' }
        ],
    },
    getters: {
        ...useGetters(),
        cameras: state => state.cameras,
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
